<template>
  <div id="app" v-bind:style="{ backgroundColor: this.appBackgroundColor }">
    <fetching-loader
      displayType="displayFixed"
      v-if="initialLoader && $route.path != previewPath"
    ></fetching-loader>
    <guestbook-navigation
      v-if="$route.path != previewPath"
      @appBackgroundColor="setBgColor"
    ></guestbook-navigation>
    <router-view />
  </div>
</template>
<script>
import bus from "./bus.js";
import FetchingLoader from "./components/globalComponents/FetchingLoader";
import Vue from 'vue';

const GuestbookNavigation = () => import("./components/GuestbookNavigation");
export default {
  name: "WellcomeGuestbookApp",
  components: {
    GuestbookNavigation,
    FetchingLoader,
  },
  data() {
    return {
      hideOverflow: false,
      initialLoader: true,
      appBackgroundColor: "#ffffff",
    };
  },
  computed: {
    previewPath() {
      let path =
        "/preview/" +
        this.$route.params.hotel +
        "/" +
        this.$route.params.guestPhase;
      return path;
    },
  },
  watch: {
    hideOverflow: function () {
      document.body.style.overflow = this.hideOverflow ? "hidden" : ""; //auto instead of '' maybe
      document.documentElement.style.overflow = this.hideOverflow
        ? "hidden"
        : "";
    },
    $route: "initialize",
  },
  created() {
    bus.$on("bodyOverflow", (state) => (this.hideOverflow = state));
  },
  methods: {
    setBgColor(bgColor) {
      this.appBackgroundColor = bgColor;
      this.initialLoader = false;
    },
    initialize() {
      Vue.prototype.$customerId = this.$route.params.hotel.split("_")[0];
      Vue.prototype.$hotelId = this.$route.params.hotel;
    }
  },
};
</script>

<style>
html,
body,
#app {
  min-height: 100vh;
}

#app {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-bottom: 15px;
}

body {
  overflow-x: hidden;
  -ms-overflow-style: none;
}

body::-webkit-scrollbar {
  display: none;
}

* {
  box-sizing: border-box;
}

.positiveToastClass {
  line-height: 2em;
  background-color: #30d45e;
  color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 1em;
  font-family: "poppins";
  margin-left: 5%;
  margin-right: 5%;
}
/*
  .toasted {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins', sans-serif;
    background-color: #48B9B2;
    text-align: center;
    width: 100px;
    color: white;
    border-radius: 5px;
    font-size: 18px;
  }
  */
.toasted-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 150px;
  margin-left: auto;
  margin-right: auto;
}

/* handle editor images */
.responsive {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}
.headerText h1,
.headerText > div > p {
  margin: 0 !important;
}
h4 {
  font-weight: 200;
}
.videoWrapper iframe {
  height: 400px;
}

@media (max-width: 426px) {
  .videoWrapper iframe {
    height: auto;
  }
}

/*
    Custom classes for quill editor
  */

.ql-align-center {
  text-align: center;
}

.ql-align-left {
  text-align: left;
}

.ql-align-right {
  text-align: right;
}

.ql-font-poppins {
  font-family: "Poppins" !important;
}

.ql-font-brandon {
  font-family: "Brandon Text Black" !important;
}

.ql-font-arial {
  font-family: "Arial" !important;
}

.ql-font-barlow {
  font-family: "Barlow" !important;
}
</style>
